import React, { useEffect, useState } from 'react';
import { isFunction } from 'lodash';
import 'antd/dist/antd.css';
import '../App.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link, useHistory } from 'react-router-dom';
import { CaretDownOutlined } from '@ant-design/icons';
import { Menu, Popover } from 'antd';
import useWebSocket from 'react-use-websocket';
import consts, { PREFIX_FRONT_URL, WS_URL } from '../consts';
import AppRouterComponent from './AppRouterComponent';
import Trustkeys from '../assets/imgs/svgs/Trustkeys';
import {
  DispatchAction,
  DispatchPrivateAction,
  InitPrivateWSIfNeed,
  InitWSIfNeed,
  Regis,
  RegisPrivate,
  UnRegisPrivate,
  ReconnectPublic,
  Reconnect,
} from '../websocket/EventHandle';
import CommonAvatar from './exchange/exchange_select/CommonAvatar';
import { WS_EVENT_LAST_PRICE_UPDATED } from '../redux/actions/setting_data/action_types';

const WS_URL_PUBLIC = `${WS_URL}${consts.PREFIX_FRONT_URL}/wsorderbook/public`;
const WS_URL_PRIVATE = `${WS_URL}${consts.PREFIX_FRONT_URL}/wsorderbook/private`;

const { SubMenu } = Menu;
let lastStick = {};

function AppComponent({
  user, history, logout, changeLanguage,
}) {
  const [isConstructorCalled, setCalledConstructor] = useState(false);
  window.h = useHistory();
  let coin, currency;
  const {
    sendMessage,
    lastMessage,
    readyState,
    sendJsonMessage,
    lastJsonMessage, getWebSocket,
  } = useWebSocket(WS_URL_PUBLIC, {
    onOpen: () => {
      ReconnectPublic();
    },
    shouldReconnect: (closeEvent) => {
      console.log(closeEvent, ': closeEvent app/features/CryptoCurrency/components/Initializing/index.js:52');
      return true;
    },
    reconnectAttempts: 1000,
    reconnectInterval: 10e3,
  });

  const {
    readyState: ready,
    sendJsonMessage: send,
    lastJsonMessage: lastJsonPrivate, getWebSocket: getWSPrivate,
  } = useWebSocket(WS_URL_PRIVATE, {
    onOpen: () => {
      if (!!user.session.token) {
        RegisPrivate(consts.WS_EVENT_AUTH, window.btoa(user.session.token), true);
        Reconnect();
      }
    },
    shouldReconnect: (closeEvent) => {
      return true;
    },
    reconnectAttempts: 1000,
    reconnectInterval: 10e3,
  });

  InitWSIfNeed(sendJsonMessage);
  InitPrivateWSIfNeed(send);

  const customLogout = () => {
    UnRegisPrivate(consts.WS_EVENT_AUTH, window.btoa(user.session.token));
    UnRegisPrivate(consts.WS_EVENT_UPDATE_COIN_ACCOUNT);
    UnRegisPrivate(consts.WS_EVENT_USER_TRANSACTION);

    logout();
  };

  const getTimeInMilisecond = (minute) => {
    switch (minute) {
      case '1':
      case '5':
      case '15':
      case '30':
      case '60': {
        return parseInt(minute) * 60000;
      }
      case '1D': {
        return 1440000;
      }
      case '1W': {
        return 10080000;
      }
      case '1M': {
        return 43200000;
      }
    }

    return 900000;
  };

  // public socket
  useEffect(() => {
    if (!lastJsonMessage) {
      return;
    }
    const {
      channel, data, options,
    } = lastJsonMessage;
    const params = channel.split(':');
    if (params.length > 1) {
      DispatchAction({ data, options }, params[0]);

      if (channel === `${consts.WS_EVENT_LAST_PRICE}:${params[1]}:${params[2]}`) {
        if (isFunction(window.onTick)) {
          let pair = new URLSearchParams(history.location.search).get("currency");
          if (window._.isEmpty(pair)) {
            coin = 'BTC';
            currency = 'USDT';
          } else {
            const [queryCoin, queryCurrency] = pair.split('/');
            coin = queryCoin;
            currency = queryCurrency;
          }
          
          if (params[1] != coin || params[2] != currency) {
            return
          }
          
          if (params[1] !== lastStick.coin || params[2] !== lastStick.currency) {
            if (!lastStick.coin && !lastStick.currency) {
              lastStick = window[`${params[1]}:${params[2]}`] || {};
              lastStick.price = lastStick?.close || "";
              lastStick.open = lastStick.price;
              lastStick.time -= (lastStick.time % getTimeInMilisecond(window.resolution));
            }
          }

          const newTime = data.time - (data.time % getTimeInMilisecond(window.resolution));
          // new session
          if (newTime > lastStick.time) {
            // window.lastBar = data;
            lastStick.volume = 0;
            data.open = lastStick.price;
            // if (params[1] === 'USDT' && params[2] === 'ETH') {
            //   console.log(data.open, ': data.open src/components/AppComponent.js:117');
            //   console.log(lastStick.price, ': lastStick.price src/components/AppComponent.js:118');
            //   console.log(data, ': data src/components/AppComponent.js:119');
            //   console.log(lastStick, ': lastStick src/components/AppComponent.js:120');
            // }
          } else {
            lastStick.volume += data.volume;
            data.volume = lastStick.volume;
            if (data.price < lastStick.high) {
              data.high = lastStick.high;
            }

            if (data.price > lastStick.low) {
              data.low = lastStick.low;
            }

            data.open = lastStick.open;
            // if (params[1] === 'USDT' && params[2] === 'ETH') {
            //   console.log(data, ': data src/components/AppComponent.js:127');
            // }
          }

          data.time = newTime;
          window.onTick(data);
          lastStick = data;
          lastStick.coin = params[1];
          lastStick.currency = params[2];
        }
      }
    } else {
      DispatchAction({ data, options }, channel);
    }
  }, [lastJsonMessage]);

  // private socket
  useEffect(() => {
    if (!lastJsonPrivate) {
      return;
    }
    const {
      channel, data, options,
    } = lastJsonPrivate;
    DispatchPrivateAction({ data, options }, channel);
  }, [lastJsonPrivate]);

  if (!isConstructorCalled) {
    if (user.isAuthenticated) {
      setCalledConstructor(true)
      RegisPrivate(consts.WS_EVENT_AUTH, window.btoa(user.session.token));
      RegisPrivate(consts.WS_EVENT_UPDATE_COIN_ACCOUNT);
      RegisPrivate(consts.WS_EVENT_USER_TRANSACTION);
    }

    Regis(consts.WS_EVENT_LAST_PRICE_UPDATED);
  }

  useEffect(() => {
    const handleInvalidToken = (e) => {
      if (e.key === 'session' && e.oldValue && !e.newValue) {
        logout();
      }
    };
    window.addEventListener('storage', handleInvalidToken);
    return function cleanup() {
      window.removeEventListener('storage', handleInvalidToken);
    };
  }, []);

  return (
    <div className="App" style={{ minWidth: "1280px", margin: 'auto' }}>
      <div className="wrap-app">
        <Menu
          mode="horizontal"
          theme="dark"
          defaultSelectedKeys={[window.location.pathname]}
          style={{ textAlign: 'left' }}
          className="menu__header sticky-top"
        >
          <Menu.Item className="menu__heading-item item-logo">
          <Link
              to={`${PREFIX_FRONT_URL}/home`}
            >
              {/* <Trustkeys /> */}
              <img src={require('../assets/imgs/AppIconRound.png')} width="55" />
              </Link>
          </Menu.Item>
          <Menu.Item className="menu__heading-item item-trustkey">
            <Link
              to={`${PREFIX_FRONT_URL}/home`}
              className="menu__heading-trustkey"
            >
              {window.$t('navigation.home_link')}
            </Link>
          </Menu.Item>
          <Menu.Item className="menu__heading-item">
            <Link
              to={`${PREFIX_FRONT_URL}/`}
              className="menu__heading-text"
            >
              {window.$t('navigation.exchange_link')}
            </Link>
          </Menu.Item>
          <Menu.Item className="menu__heading-item">
            <Link
              to={`${PREFIX_FRONT_URL}/market`}
              className="menu__heading-text"
            >
              {window.$t('Market')}
            </Link>
          </Menu.Item>
          <SubMenu
            className=" menu__heading-item"
            title={(
              <span className="menu__heading-text menu_heading-nn">
                {window.$t('navigation.explore')}
                <CaretDownOutlined style={{ marginLeft: 6 }} />
              </span>
            )}
          >
            <Menu.Item className="menu__heading-item">
              <Link
                to={`${PREFIX_FRONT_URL}/referral`}
                className="menu__heading-text"
              >
                {window.$t('navigation.referral')}
              </Link>
            </Menu.Item>
  
            <Menu.Item className="menu__heading-item">
              <Link
                to={`${PREFIX_FRONT_URL}/campaign`}
                className="menu__heading-text"
              >
                {window.$t('navigation.campaign')}
              </Link>
            </Menu.Item>

          </SubMenu>

          {user.isAuthenticated ? (
            <Menu.Item
              className="menu__heading-item flr menu__avatar"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <CommonAvatar info={user.info} history={history} logout={logout} />
            </Menu.Item>
          ) : ''}
          <SubMenu
            className=" menu__heading-item flr"
            title={(
              <span className="menu__heading-text menu_heading-nn">
                {window.$t('navigation.language_link')}
                <CaretDownOutlined style={{ marginLeft: 6 }} />
              </span>
            )}
          >
            <Menu.Item
              onClick={() => changeLanguage(window.c.EN)}
              className="menu__heading-item"
            >
              <span className="menu__heading-text">
                {window.$t('navigation.language_sub_en_link')}
              </span>
            </Menu.Item>
            <Menu.Item
              onClick={() => changeLanguage(window.c.VI)}
              className="menu__heading-item"
            >
              <span className="menu__heading-text">
                {window.$t('navigation.language_sub_vi_link')}
              </span>
            </Menu.Item>
          </SubMenu>
          <Menu.Item className="menu__heading-item flr menu__tutorial">
            <Link
              to={`${PREFIX_FRONT_URL}/${window.c.routes.GUIDE}`}
              className="menu__heading-text"
            >
              {window.$t('navigation.tutorial')}
            </Link>
          </Menu.Item>
          {
            user.isAuthenticated
              ? (
                <Menu.Item className="menu__heading-item flr menu__tutorial">
                  <Link
                    to={`${PREFIX_FRONT_URL}/${window.c.routes.NOTIFICATION}`}
                    className="menu__heading-text"
                  >
                    {window.$t('notification_page')}
                  </Link>
                </Menu.Item>
              ) : ''
          }

          {
            !user.isAuthenticated && (
              <Menu.Item className="flr menu__heading-item menu__login">
                <Link
                  to={`${PREFIX_FRONT_URL}/login`}
                  className="menu__heading-text"
                >
                  {window.$t('navigation.login_link')}
                </Link>
              </Menu.Item>
            )
          }
          {
            user.isAuthenticated
              ? (
                <Menu.Item className="menu__heading-item flr menu__login">
                  <Link
                    to={`${PREFIX_FRONT_URL}/${window.c.routes.USER_WALLET}`}
                    className="menu__heading-text"
                  >
                    {window.$t('navigation.wallet_link')}
                  </Link>
                </Menu.Item>
              )
              : ''
          }
          <Menu.Item className="menu__heading-item flr menu__qa-link">
            <Link
              to={`${PREFIX_FRONT_URL}/${window.c.routes.FAQS}`}
              className="menu__heading-text"
            >
              {window.$t('navigation.qa_link')}
            </Link>
          </Menu.Item>
        </Menu>
        <div className="App-header">
          <AppRouterComponent logout={customLogout} />
        </div>
      </div>
    </div>
  );
}

export default AppComponent;
